import ReactApexChart from "react-apexcharts";
import { colorPalette } from "../sensors/chartOption";
import { useTranslation } from "react-i18next";

interface CategoryData {
    category: string;
    refusedCount: number;
    todoCount: number;
    overdueCount: number;
    toverifyCount: number;
}

interface PeriodicQuantityChartData {
    categoryDataArray: CategoryData[];
}

const QuantityPeriodic = ({ categoryDataArray }: PeriodicQuantityChartData) => {
    const { t } = useTranslation(["periodical"]);

    const categories = categoryDataArray.map(item => item.category);

    const colors = ['#acadac', '#fd4343', '#fe914d', '#65a6fa'];

    const series = [
        {
            name: t('info.Todo'),
            data: categoryDataArray.map(item => item.todoCount)
        },
        {
            name: t('info.Refused'),
            data: categoryDataArray.map(item => item.refusedCount)
        },
        {
            name: t('info.Overdue'),
            data: categoryDataArray.map(item => item.overdueCount)
        },
        {
            name: t('info.ToVerify'),
            data: categoryDataArray.map(item => item.toverifyCount)
        }
    ];

    const chartData = {
        options: {
            chart: {
                id: "quantity",
                stacked: true,
                toolbar: {
                    show: false,
                },
                height: 1000,
            },
            tooltip: {
                enabled: true,
            },
            xaxis: {
                categories: categories,
                labels: {
                    show: categories.length <= 4, 
                    formatter: function (val: string) {
                        const maxChars = 15;
                        return val.length > maxChars ? val.substring(0, maxChars) + '...' : val;
                    }
                },
            },
            colors: colors,
            dataLabels: {
                enabled: false,
            },
            legend: {
                show: false,
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '55%',
                    endingShape: 'rounded',
                    stacked: true,
                },
            },
            title: {
                text: '',
                floating: false,
            },
        },
        series: series,
    };

    return (
        <ReactApexChart
            options={chartData.options}
            series={chartData.series}
            type="bar"
            height='120%'
            width='120%'
        />
    );
};

export default QuantityPeriodic;
